import React from 'react';
import classNames from 'classnames/bind';
import SVG from 'react-inlinesvg';
import frameListSvg from 'assets/icons/frame.svg';
import chevronDownSvg from 'assets/icons/arrow_light_down.svg';
import Chip from 'lib/Chip';
import { Color } from 'lib/Chip/Chip.types';
import { getInputBorderStyle } from 'lib/BaseInput/BaseInput';
import { InputShape, InputTheme } from 'components/common/types/Input.types';
import styles from 'lib/AsyncSelect/AsyncSelect.pcss';
import { FrameListControlButtonProps } from './FilterFrameList.types';

const cx = classNames.bind(styles);

const FrameListControlButton: React.FC<FrameListControlButtonProps> = ({
  isDisabled,
  isOpen,
  totalCount,
  onToggle,
}) => {
  return (
    <div
      className={cx(
        'min-h-[38px] shadow-inner-sm',
        getInputBorderStyle({
          isDisabled,
          shape: InputShape.ROUNDED_MEDIUM,
          theme: InputTheme.LIGHT,
        }),
      )}
    >
      <div className={cx('w-full default', 'async-select-shadow', 'async-select')}>
        <div
          className={cx('react-select__control min-h-9', {
            'react-select__control--is-disabled cursor-not-allowed': isDisabled,
            'react-select__control--is-focused': isOpen,
            'cursor-pointer': !isDisabled,
          })}
          onClick={onToggle}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onToggle();
            }
          }}
          role="button"
          tabIndex={0}
        >
          <div className="flex items-center w-full h-full">
            <SVG className="fill-current w-4 h-4 text-neutral-600 mr-1 flex-shrink-0" src={frameListSvg} />
            <div className="react-select__value-container flex-1 flex items-center min-h-8">
              <div className={cx('react-select__single-value', 'text-neutral-950')}>
                <div className="flex items-center gap-2">
                  <span>Frame list</span>
                  <Chip label={totalCount.toString()} color={Color.PRIMARY} />
                </div>
              </div>
            </div>
            <div className="react-select__indicators flex items-center">
              <div className="react-select__indicator">
                <SVG
                  src={chevronDownSvg}
                  className={cx('transform transition-transform fill-neutral-600', {
                    'rotate-180': isOpen,
                  })}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrameListControlButton;
